import { render, staticRenderFns } from "./PartnerMap.vue?vue&type=template&id=061f588d&scoped=true"
import script from "./PartnerMap.vue?vue&type=script&lang=ts"
export * from "./PartnerMap.vue?vue&type=script&lang=ts"
import style0 from "./PartnerMap.vue?vue&type=style&index=0&id=061f588d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "061f588d",
  null
  
)

export default component.exports